import './about.css'
import { useEffect, useRef, useState } from "react";
import { HelmetProvider } from 'react-helmet-async';
import Image1 from '../../assets/Images/About/Hero-Section.jpg'
import Image2 from '../../assets/Images/About/OurStory.jpg'
import Image3 from '../../assets/Images/About/Goals.jpg'

import Icon1 from '../../assets/Images/Elements/target.png'
import Icon2 from '../../assets/Images/Elements/vision.png'
import Icon3 from '../../assets/Images/Elements/mission.png'

import Image4 from '../../assets/Images/Founders/image 354.png'

import Graphic1 from '../../assets/Images/Elements/M-Orange.svg'
import Graphic2 from '../../assets/Images/Elements/Line.svg'

import Header from "../../assets/components/01_header/header"
import Footer from "../../assets/components/02_footer/footer"
import SubSection from "../../assets/components/01_components/05_component/05_component"

export default function About() {

    const [position, setPosition] = useState({ x: 0, y: 0 });
    const eye1 = useRef(null);
    const eye2 = useRef(null);

    const eye3 = useRef(null);
    const eye4 = useRef(null);

    const eye5 = useRef(null);
    const eye6 = useRef(null);

    {/*
    useEffect(() => {
        const cursor = document.querySelector(".Cursor-Fixed");

        const enter = () => cursor.classList.add("hover");
        const leave = () => cursor.classList.remove("hover");

        const elements = document.querySelectorAll("a, button");

        elements.forEach(el => {
            el.addEventListener("mouseenter", enter);
            el.addEventListener("mouseleave", leave);
        });

        return () => {
            elements.forEach(el => {
                el.removeEventListener("mouseenter", enter);
                el.removeEventListener("mouseleave", leave);
            });
        };
    }, []);
    */}
    useEffect(() => {
        const move = (e) => {
        setPosition({
            x: e.clientX,
            y: e.clientY,
        });
        };

        window.addEventListener("mousemove", move);

        return () => window.removeEventListener("mousemove", move);
    }, []);

    useEffect(() => {
        const moveEye = (eye, e) => {
            if (!eye) return;

            const rect = eye.getBoundingClientRect();
            const ball = eye.querySelector(".About-StorySection-Details-Character-Main-Eye-Balls");
            if (!ball) return;

            const eyeX = rect.left + (rect.width / 2);
            const eyeY = rect.top + (rect.height / 2);

            const dx = e.clientX - eyeX;
            const dy = e.clientY - eyeY;

            const distance = Math.sqrt(dx * dx + dy * dy);

            const radiusX = rect.width * 0.34;
            const radiusY = rect.height * 0.36;

            
            let x = dx * 0.5;
            let y = dy * 0.5;

            x = Math.max(-radiusX, Math.min(radiusX, x));
            y = Math.max(-radiusY, Math.min(radiusY, y));

            ball.style.transform = `translate(-50%, -50%) translate(${x}px, ${y}px)`;
        };

        const eyes = [eye1, eye2, eye3, eye4, eye5, eye6];

        const handleMouseMove = (e) => {
            eyes.forEach(ref => moveEye(ref.current, e));
        };

        window.addEventListener("mousemove", handleMouseMove);

        return () => {
            window.removeEventListener("mousemove", handleMouseMove);
        };

    }, []);

    return (
        <div>
            <HelmetProvider>
                <title>Leading Digital Solutions for Businesses in Mumbai</title>
                <meta name="Adstrate is a digital marketing agency in Mumbai offering social media marketing in Mumbai, Instagram marketing agency services, and strategic social media content creation." />
                <link rel="canonical" href="https://adstrate.in/about" />
            </HelmetProvider>
            <Header />
            <div className='About-HeroSection'>
                <img src={Image1} alt="" />
                <div className='About-HeroSection-Details'>
                    <img src={Graphic1} alt="" />
                    <img src={Graphic2} alt="" />
                    <h1>Digital Marketing Agency in Mumbai Driving Business <span>Growth</span></h1>
                </div>
            </div>
            <div className='About-StorySection'>
                <div className='About-StorySection-Details'>
                    <div className='About-StorySection-Details-Info'>
                        <h2>About Adstrate</h2>
                        <p>
                            Founded by Gaurav Chakravartty and Prerna Patel, Adstrate is a results-oriented digital marketing agency in Mumbai dedicated to building strong, scalable, and high-impact digital brands. Combining strategic thinking with creative execution, we provide end-to-end digital services, including social media marketing, website design and development, and social media content creation tailored to help businesses achieve their unique growth objectives.
                        </p>
                    </div>
                </div>
                <div className='About-StorySection-Character-Main-Flex'>
                    <div className='About-StorySection-Character-Main-Flex-Side'>
                        <div className='About-StorySection-Character-Main-Chara '>
                            <div className='About-StorySection-Details-Character'>
                                <div className='About-StorySection-Details-Character-Main-Eye' ref={eye1}>
                                    <div className='About-StorySection-Details-Character-Main-Eye-Balls'></div>
                                </div>
                                <div className='About-StorySection-Details-Character-Main-Eye' ref={eye2}>
                                    <div className='About-StorySection-Details-Character-Main-Eye-Balls'></div>
                                </div>
                            </div>
                            <div class="character Chara-One">
                                <div class="About-StorySection-Details-Character-Main-Mouth">
                                    <div class="About-StorySection-Details-Character-Main-Mouth-Piece-One"></div>
                                </div>
                                <span class="About-StorySection-Character-Main-key">strategy</span>
                            </div>
                        </div>
                        <div className='About-StorySection-Character-Main-Chara'>
                            <div className='About-StorySection-Details-Character Chara-Eye-Two'>
                                <div className='About-StorySection-Details-Character-Main-Eye' ref={eye3}>
                                    <div className='About-StorySection-Details-Character-Main-Eye-Balls'></div>
                                </div>
                                <div className='About-StorySection-Details-Character-Main-Eye' ref={eye4}>
                                    <div className='About-StorySection-Details-Character-Main-Eye-Balls'></div>
                                </div>
                            </div>
                            <div class="character Chara-Two">
                                <div class="About-StorySection-Details-Character-Main-Mouth">
                                    <div className='About-StorySection-Details-Character-Main-Mouth-Piece-Two'></div>
                                </div>
                                <span class="About-StorySection-Character-Main-key">creativity</span>
                            </div>
                        </div>
                    </div>
                    <div className='About-StorySection-Character-Main-Flex-Side'>
                        <div className='About-StorySection-Character-Main-Chara'>
                            <div className='About-StorySection-Details-Character'>
                                <div className='About-StorySection-Details-Character-Main-Eye' ref={eye5}>
                                    <div className='About-StorySection-Details-Character-Main-Eye-Balls'></div>
                                </div>
                                <div className='About-StorySection-Details-Character-Main-Eye' ref={eye6}>
                                    <div className='About-StorySection-Details-Character-Main-Eye-Balls'></div>
                                </div>
                            </div>
                            <div class="character Chara-Three">
                                <div class="About-StorySection-Details-Character-Main-Mouth">
                                    <div className='About-StorySection-Details-Character-Main-Mouth-Piece-Three'></div>
                                </div>
                                <span class="About-StorySection-Character-Main-key">growth</span>
                            </div>
                        </div>
                    </div>
                </div>
                {/*
                <div className='About-StorySection-Details-Character-Main'>
                    <div className='About-StorySection-Details-Character'>
                        <div className='About-StorySection-Details-Character-Main-Eye' ref={eye1}>
                            <div>
                                <div className='About-StorySection-Details-Character-Main-Eye-Balls'></div>
                            </div>
                        </div>
                        <div className='About-StorySection-Details-Character-Main-Eye' ref={eye2}><div className='About-StorySection-Details-Character-Main-Eye-Balls'></div></div>
                    </div>
                </div>
                */}
            </div>
            <div className='About-GoalSection'>
                <div className='About-GoalSection-Flex-Card'>
                    <img src={Icon1} alt="" />
                    <h3>Goal</h3>
                    <p>
                        We drive measurable growth by building trusted partnerships, innovating with digital trends, and delivering creative solutions that help brands establish a strong, consistent digital identity.
                    </p>
                </div>
                <div className='About-GoalSection-Flex-Card'>
                    <img src={Icon2} alt="" />
                    <h3>Vision</h3>
                    <p>
                        To become the most trusted digital marketing company in Mumbai, empowering brands of all sizes to thrive in the digital landscape through innovation, strategy, and measurable impact.
                    </p>
                </div>
                <div className='About-GoalSection-Flex-Card'>
                    <img src={Icon3} alt="" />
                    <h3>Mission</h3>
                    <p>
                        Our mission is to deliver tailored digital marketing strategies that are creative, performance-focused, and aligned with real business goals. We simplify digital marketing by managing your online presence with transparency, precision, and consistency, ensuring sustainable growth for our clients.
                    </p>
                </div>
            </div>
            <SubSection />
            {/*
            <div className='About-FounderSection'>
                <h2>Our Founders</h2>
                <div className='About-FounderSection-Flex'>
                    <div className='About-FounderSection-Flex-Cards'>
                        <img src={Image4} alt="" />
                        <div className='About-FounderSection-Flex-Cards-Info'>
                            <h3>Gaurav Chakravartty</h3>
                            <p>Founder</p>
                            <span className='Quotes'>
                                Strategic leader driving digital growth through data-led, result-focused marketing.
                            </span>
                        </div>
                    </div>
                    <div className='About-FounderSection-Flex-Cards'>
                        <img src={Image4} alt="" />
                        <div className='About-FounderSection-Flex-Cards-Info'>
                            <h3>Prerna Patel</h3>
                            <p>Founder</p>
                            <span className='Quotes'>
                                Creative strategist shaping brand stories through impactful content and design thinking.
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            */}
            <Footer />
        </div>
    );
}